import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import RolesHelper from "../../common/services/permissions/RolesHelper";
import "./Forbidden.scss";

// [CANA-654] Shown in place of a page whose view right the user lost while it
// was open (a superuser changed their group). A page opened without the right
// still redirects, see Can.js.
const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="forbidden">
      <Result
        status="403"
        title="Access denied"
        subTitle="You don't have permission to view this page."
        extra={
          <Button type="primary" onClick={() => navigate(RolesHelper.getRedirectPage(), { replace: true })}>
            Go to home
          </Button>
        }
      />
    </div>
  );
};

export default Forbidden;
